<nav
    id="widgets"
    class="widgets">
    <style ng-bind-html="getWidgetStyle()"></style>
    <ul class="toolbar">
        <div>
            <li tabindex="1">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="importToolBtn"
                    title="{{getTooltip('IMPORT_WINDOW', 'Import Survey Data')}}"
                    (click)="onClick('ImportSurveyData')"
                    right-click="importSurveyData"
                    [ngClass]="{active : isWidgetActive('ImportSurveyData'),
                               'nlrp-suspended': isWidgetSuspended('IMPORT_WINDOW')}"
                    [disabled]="importDisabled()">
                    <i class="nlrp-icon nlrp-icon-import"></i>
                </button>
                @if (isWidgetActive('ImportSurveyData')) {
                    <div>
                        <nlr-import-survey-data></nlr-import-survey-data>
                    </div>
                }
            </li>
            <li tabindex="2">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="cadastreToolBtn"
                    title="{{getTooltip('SHOW_HIDE_CADASTRE', 'Show / Hide the Cadastre')}}"
                    (click)="onClickShowHideCadastre()"
                    [ngClass]="{active : isShowHideCadastreActive()}"
                    [disabled]="cadastreToolsRibbonButtonDisabled()">
                    <i class="nlrp-icon nlrp-icon-show-hide-layers"></i>
                </button>
            </li>
            <li tabindex="3">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="constructionToolBtn"
                    title="{{getTooltip('CONSTRUCTION_TOOLS_WINDOW', 'Construction Tools')}}"
                    (click)="onClick('ConstructionTools')"
                    right-click="constructionTools"
                    [ngClass]="{active : isWidgetActive('ConstructionTools'),
                                   'nlrp-suspended': isWidgetSuspended('CONSTRUCTION_TOOLS_WINDOW')}"
                    [disabled]="constructionToolsRibbonButtonDisabled()">
                    <i class="nlrp-icon nlrp-icon-construct-features"></i>
                </button>
                @if (isWidgetActive('ConstructionTools')) {
                    <div>
                        <construction-tools></construction-tools>
                    </div>
                }
            </li>
            <li tabindex="4">
                <nlr-annotations-tools></nlr-annotations-tools>
            </li>

            <li tabindex="19">
                <nlr-enlargement></nlr-enlargement>
            </li>
        </div>

        <div>
            <li tabindex="5">
                <nlr-scale-features
                    [disabled]="isPrintPreview()"
                    [active]="isScaleAnnotationToolActive()">
                </nlr-scale-features>
            </li>
            <li tabindex="5">
                <nlr-move-annotation [disabled]="moveAnnotationDisabled()"></nlr-move-annotation>
            </li>
            <li tabindex="5">
                <nlr-rotate-annotation [disabled]="rotateAnnotationDisabled()"></nlr-rotate-annotation>
            </li>
            <nlr-annotation [disabled]="alignFlipAnnotationDisabled()"></nlr-annotation>
            <li
                tabindex="6"
                class="show-hide-selected-features">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="showToolBtn"
                    title="{{getTooltip('SHOW_FEATURES', 'Unhide selected features')}}"
                    (click)="showFeatures(true)"
                    [disabled]="showFeaturesDisabled()">
                    <i class="nlrp-icon nlrp-icon-set-visible"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="hideToolBtn"
                    title="{{getTooltip('HIDE_FEATURES', 'Hide selected features')}}"
                    (click)="showFeatures(false)"
                    [disabled]="hideFeaturesDisabled()">
                    <i class="nlrp-icon nlrp-icon-set-not-visible"></i>
                </button>
                <nlr-visibility-settings></nlr-visibility-settings>
            </li>
            <li tabindex="7">
                <nlr-display-preferences></nlr-display-preferences>
            </li>
        </div>

        <div>
            <nlr-zoom-scale></nlr-zoom-scale>
            <li tabindex="11">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="lockToolBtn"
                    title="{{getTooltip('LOCK_AUTO_PAN', 'Enable / disable auto-panning to features selected in the Attribute Viewer')}}"
                    (click)="toggleLockAutoPan()"
                    [ngClass]="{'active': lockAutoPanActive()}"
                    [disabled]="lockAutoPanDisabled()">
                    <i class="nlrp-icon nlrp-icon-lock-auto-pan"></i>
                </button>
            </li>
            <li tabindex="12">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    [ngClass]="{active : isIdentifyFeaturesActive()}"
                    title="{{getTooltip('IDENTIFY_FEATURES', 'Identified Features Tool')}}"
                    (click)="toggleIdentifyFeatures()"
                    id="identifiedToolBtn">
                    <i class="nlrp-icon nlrp-icon-identify-features"></i>
                </button>
                @if (isWidgetActive('IdentifyFeatures')) {
                    <div>
                        <nlr-identify-features></nlr-identify-features>
                    </div>
                }
            </li>
            <li tabindex="13">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="selectAllToolBtn"
                    title="{{getTooltip('SELECT_ALL_FEATURES', 'Select all features')}}"
                    (click)="selectAllFeatures()"
                    [disabled]="selectAllFeaturesDisabled()">
                    <i class="nlrp-icon nlrp-icon-select-all"></i>
                </button>
            </li>
            <nlr-selection-methods [disabled]="selectionMethodsDisabled()"></nlr-selection-methods>
            <li tabindex="16">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="deselectAllToolBtn"
                    title="{{getTooltip('DESELECT_ALL_FEATURES', 'Clear selected features')}}"
                    (click)="clearSelectedFeatures()"
                    [disabled]="clearSelectedFeaturesDisabled()">
                    <i class="nlrp-icon nlrp-icon-remove-circle"></i>
                </button>
            </li>
            <li
                tabindex="17"
                class=" removals_p5">
                <nlr-removals [disabled]="removalsDisabled()"></nlr-removals>
            </li>
        </div>
        <div>
            <nlr-map-mode></nlr-map-mode>
            <li tabindex="20">
                <nlr-display-mode></nlr-display-mode>
            </li>
        </div>

        <div>
            <li tabindex="21">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="exportToolBtn"
                    title="{{getTooltip('EXPORT_WINDOW', 'Export Survey Data')}}"
                    (click)="onClickExport()"
                    right-click="exportSurveyData"
                    [ngClass]="{active : isWidgetActive('ExportSurveyData')}"
                    [disabled]="exportDisabled()">
                    <i class="nlrp-icon nlrp-icon-export"></i>
                </button>
                @if (isWidgetActive('ExportSurveyData')) {
                    <div>
                        <nlr-export-survey-data></nlr-export-survey-data>
                    </div>
                }
            </li>
            <li tabindex="22">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="printAreaToolBtn"
                    title="{{getTooltip('PRINT_AREA_WINDOW', 'Set Print Area')}}"
                    (click)="onClick('PrintArea')"
                    right-click="printArea"
                    [ngClass]="{active : isWidgetActive('PrintArea')}"
                    [disabled]="printAreaDisabled()">
                    <i class="nlrp-icon nlrp-icon-print-area"></i>
                </button>
                @if (isWidgetActive('PrintArea')) {
                    <div>
                        <nlr-print-area></nlr-print-area>
                    </div>
                }
            </li>
            <li tabindex="23">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="printPlanToolBtn"
                    title="{{getTooltip('PRINT_PLAN_WINDOW', 'Print plan to pdf')}}"
                    (click)="printToPdf()"
                    [disabled]="printPlanDisabled()">
                    <i class="nlrp-icon nlrp-icon-print"></i>
                </button>
            </li>
            <li tabindex="24">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="validateToolBtn"
                    title="{{getTooltip('VALIDATE', 'Validate spatial features')}}"
                    (click)="validate()"
                    [disabled]="validateDisabled()">
                    <i class="nlrp-icon nlrp-icon-validate"></i>
                </button>
            </li>
            <li tabindex="25">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="attributeViewerToolBtn"
                    title="{{getTooltip('ATTRIBUTE_VIEWER_WINDOW', 'Attribute Viewer')}}"
                    (click)="onClick('AttributeViewer')"
                    [ngClass]="{active : isWidgetActive('AttributeViewer')}"
                    [disabled]="attributeViewerDisabled()"
                    right-click="attributeViewer">
                    <i class="nlrp-icon nlrp-icon-open-close-attribute-viewer"></i>
                </button>
                @if (isWidgetActive('AttributeViewer')) {
                    <div>
                        <nlr-attribute-viewer></nlr-attribute-viewer>
                    </div>
                }
            </li>
            <li
                tabindex="26"
                class="spatial_p5">
                <nlr-spatial-snapshots [disabled]="snapshotsDisabled()"></nlr-spatial-snapshots>
            </li>
            <li tabindex="27">
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="saveToolBtn"
                    title="{{getTooltip('SAVE', 'Save spatial features')}}"
                    (click)="save()"
                    [disabled]="saveDisabled() || (editViewDesignPermissions | disabledByPermissions)">
                    <i class="nlrp-icon nlrp-icon-save"></i>
                </button>
            </li>
        </div>
    </ul>
</nav>
